<template>
  <div>
    <div v-if="loadingOverlay === true"><div class="lds-dual-ring"></div></div>
    <div v-else>
      <div class="alert alert-dismissible fade show" :class="alertType" v-if="displayAlert==true">
        <button type="button" aria-hidden="true" class="close" data-dismiss="alert"
          aria-label="Close" @click="displayAlert = false">
          <i class="nc-icon nc-simple-remove"></i>
        </button>
        <span>{{alertMsg}}</span>
      </div>
      <!-- New Campaign File Upload -->
      <div class="row">
        <div class="col-md-8">
          <p-button outline type="info" size="sm" round @click="$router.go(-1)">
            <i class="fa fa-chevron-circle-left"></i>
            Back
          </p-button>
        </div>
        <div class="col-md-4">
          <p-button @click="addNewCampaignFile" round outline type="info" size="sm"
            style="float: right;">+ Upload Content</p-button>
          <input style="display: none" type="file" ref="profile" accept="image/*,video/*" @change="onFilePicked">
        </div>
      </div>

      <h4 class="card-title pl-3">
        <small>Campaign Contents</small>
      </h4>

      <!-- Campaign Files -->
      <div v-if="campaignContentsStore.length > 0">
        <div class="card">
          <div class="row" style="padding: 25px">
            <div class="col-sm-6 col-lg-3" v-for="content in campaignContentsStore" :key="content._id">
              <div class="hovereffect post-click" @click="$router.push(`/influencer/collaboration/content-detail/`+ content._id)">
                <span style="width:100%">
                  <img v-if="content.contentUrl.split('.').pop().toLowerCase().indexOf('jpeg', 'jpg', 'png') !== -1"
                    :src="s3 + '/' + content.contentUrl" alt class="img-responsive campaign-file"/>
                  <iframe v-else allowfullscreen frameBorder="0"  :src="s3 + '/' + content.contentUrl" class="iframe"/>
                </span>
                <div class="overlay">
                  <div class="overlay-stats">
                    <div style="padding:15px;">
                      <i v-if="content.contentUrl.split('.').pop().toLowerCase().indexOf('jpeg', 'jpg', 'png') !== -1" class="far fa-image"></i>
                      <i v-else class="fas fa-video"></i>
                    </div>
                    <p>Status: {{content.status}}</p>
                    <p class="icon-links">VIEW DETAIL</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="card" style="padding: 30px">No campaign files</div>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
import store from '@/store/index.js'
import { mapGetters } from "vuex"
import { config } from '@/config/s3-bucket'
import { Tooltip } from 'element-ui'

export default {
  name: 'CampaignContentsInfluencer',
  components: { [Tooltip.name]: Tooltip },
  data() {
    return {
      alertMsg: '',
      alertType: '',
      displayAlert: false,
      campaignFiles: [],
      loadingOverlay: false,
      loadingOverlayText: false,
      s3: config.s3Url
    }
  },
  created() {
    this.loadingOverlay = true
    store.dispatch('getListOfCampaignContent', this.$route.params.campaignId).then(() => {
      this.loadingOverlay = false
    })
  },
  computed: { ...mapGetters(["campaignContentsStore"]) },
  methods: {
    addNewCampaignFile() {      
      this.$refs.profile.click()
    },
    onFilePicked(e) {
      const file = e.target.files[0]
      const data = this
      store.dispatch('uploadCampaignFile', {
        file: file, 
        influencer: this.$route.params.candidateId,
        campaign: this.$route.params.campaignId
      }).then((response) => {
        if (response) {
          data.alertType = 'alert-success'
          data.alertMsg = 'Campaign file uploaded successfully!'
        } else {
          data.alertType = 'alert-danger'
          data.alertMsg = 'Campaign file not uploaded, try again!'
        }
        data.displayAlert = true
      })
    }
  }
}
</script>

<style scoped src="./style/index.css"/>